import axios from 'axios';
import authHeader from "@/service/auth-header";

class NoteTemplateService {

    async getCompanyNoteTemplates(companyId) {
        return await axios.get(`/api/notetemplate/${companyId}`, {headers: authHeader()})
    }

    async createNoteTemplate(companyId, data) {
      return await axios.post(`/api/notetemplate/${companyId}`, data,{ headers: authHeader() });
    }

    async updateNoteTemplate(noteTemplateId, data) {
        return await axios.put(`/api/notetemplate/${noteTemplateId}`, data,{ headers: authHeader() });
    }

    async deleteNoteTemplate(noteTemplateId) {
        return await axios.delete(`/api/notetemplate/${noteTemplateId}`,{ headers: authHeader() })
    }

}

export default new NoteTemplateService();
